module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-4.webp?b76913fc";